import type { WiwState } from '@/store';

export const getMessageReaders = (state: WiwState) => {
  return state.workchat.messageReaders;
};
